import routes from '@ts/containers/App/routes';
import * as activityPageActions from '@ts/containers/ActivityPage/actions';
import * as activityReviewsPageActions from '@ts/containers/ActivityReviewsPage/actions';
import * as blogPostPageActions from '@ts/containers/BlogPostPage/actions';
import * as storyPageActions from '@ts/containers/StoryPage/actions';
import * as contentPageActions from '@ts/containers/ContentPage/actions';

const actions = {
    [routes.activityPage]: activityPageActions,
    [routes.activityReviewsPage]: activityReviewsPageActions,
    [routes.blogPostPage]: blogPostPageActions,
    [routes.storyPage]: storyPageActions,
    [routes.contentPage]: contentPageActions,
};

export default function presetState(dispatch) {
    return (presetObject) => {
        switch (presetObject.loadable.path) {
            case routes.activityPage:
            case routes.activityReviewsPage:
            case routes.blogPostPage:
            case routes.storyPage:
                dispatch(
                    actions[presetObject.loadable.path].fetchUserImagesSuccessfully(
                        presetObject.result[1]
                    )
                );
                break;
            case routes.contentPage:
                dispatch(actions[presetObject.loadable.path].resetContents());
                dispatch(
                    actions[presetObject.loadable.path].setParams(presetObject.loadable.params)
                );
                dispatch(
                    actions[presetObject.loadable.path].fetchPageSuccessfully(
                        presetObject.result[0]
                    )
                );
                if (presetObject.loadable.path === routes.activityPage) {
                    dispatch(
                        actions[presetObject.loadable.path].fetchUserImagesSuccessfully(
                            presetObject.result[1]
                        )
                    );
                    dispatch(
                        actions[presetObject.loadable.path].fetchConfigSuccessfully(
                            presetObject.result[2]
                        )
                    );
                }
                break;
        }
    };
}
